import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const printPhotoAlbum: 'a' | 'b' | 'c' = getFeature('print-photo-album') || 'a';
